module.exports = __webpack_public_path__ + "img/pms9.d5f17382.jpg";